import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.4_@playwright+test@1.54.1_react-dom@19.1.4_react@19.1.4__react@19.1.4_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.4_@playwright+test@1.54.1_react-dom@19.1.4_react@19.1.4__react@19.1.4_sass@1.77.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/authors/page.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommitmentDropdown"] */ "/app/src/components/tables/controls/CommitmentDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderCommitmentDropdown"] */ "/app/src/components/tables/controls/HeaderCommitmentDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingToggle"] */ "/app/src/components/tables/controls/PricingToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollableTable"] */ "/app/src/components/tables/layout/ScrollableTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MaterialNavbar"] */ "/app/src/Header/MaterialNavbar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["usePricingToggle"] */ "/app/src/providers/PricingToggle/index.tsx");
